/* ============================================
   FLAVOR THEME — Collection Filters
   AJAX filtering and sorting
   ============================================ */

(function () {
  'use strict';

  var collectionSection = document.querySelector('[data-collection-section]');
  if (!collectionSection) return;

  var filterForm = collectionSection.querySelector('[data-filter-form]');
  var productGrid = collectionSection.querySelector('[data-product-grid]');
  var activeFiltersContainer = collectionSection.querySelector('[data-active-filters]');
  var sortSelect = collectionSection.querySelector('[data-sort-select]');
  var resultsCount = collectionSection.querySelector('[data-results-count]');
  var sectionId = collectionSection.dataset.sectionId;
  var filterDrawer = collectionSection.querySelector('[data-filter-drawer]');

  /* --- AJAX filter/sort --- */
  function applyFilters(resetPage) {
    if (!filterForm) return;

    var formData = new FormData(filterForm);
    var params = new URLSearchParams();

    formData.forEach(function (value, key) {
      if (value) params.append(key, value);
    });

    /* Sort */
    if (sortSelect && sortSelect.value) {
      params.set('sort_by', sortSelect.value);
    }

    if (resetPage) params.delete('page');

    var url = window.location.pathname + '?' + params.toString();

    /* Update URL */
    window.history.pushState({}, '', url);

    /* Fetch new content */
    productGrid.classList.add('flavor-loading');

    Flavor.fetchSection(url, sectionId).then(function (doc) {
      var newGrid = doc.querySelector('[data-product-grid]');
      var newActiveFilters = doc.querySelector('[data-active-filters]');
      var newCount = doc.querySelector('[data-results-count]');
      var newPagination = doc.querySelector('.flavor-pagination');
      var currentPagination = collectionSection.querySelector('.flavor-pagination');

      if (newGrid) productGrid.innerHTML = newGrid.innerHTML;
      if (newActiveFilters && activeFiltersContainer) activeFiltersContainer.innerHTML = newActiveFilters.innerHTML;
      if (newCount && resultsCount) resultsCount.textContent = newCount.textContent;
      if (currentPagination && newPagination) {
        currentPagination.innerHTML = newPagination.innerHTML;
      } else if (newPagination && !currentPagination) {
        productGrid.insertAdjacentElement('afterend', newPagination);
      } else if (!newPagination && currentPagination) {
        currentPagination.remove();
      }

      productGrid.classList.remove('flavor-loading');

      /* Re-observe for animations */
      if (window.Flavor && Flavor.observeAnimations) Flavor.observeAnimations();
    });
  }

  /* --- Event listeners --- */
  if (filterForm) {
    filterForm.addEventListener('change', function () {
      applyFilters(true);
    });
  }

  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      applyFilters(true);
    });
  }

  /* Remove active filter */
  collectionSection.addEventListener('click', function (e) {
    var removeBtn = e.target.closest('[data-remove-filter]');
    if (!removeBtn) return;
    e.preventDefault();

    var paramName = removeBtn.dataset.paramName;
    var paramValue = removeBtn.dataset.paramValue;

    if (filterForm) {
      var inputs = filterForm.querySelectorAll('[name="' + paramName + '"]');
      inputs.forEach(function (input) {
        if (input.type === 'checkbox' && input.value === paramValue) {
          input.checked = false;
        }
      });
    }

    applyFilters(true);
  });

  /* Clear all filters */
  collectionSection.addEventListener('click', function (e) {
    if (!e.target.closest('[data-clear-filters]')) return;
    e.preventDefault();

    if (filterForm) {
      filterForm.querySelectorAll('input[type="checkbox"]').forEach(function (cb) { cb.checked = false; });
      filterForm.querySelectorAll('input[type="number"]').forEach(function (n) { n.value = ''; });
    }

    applyFilters(true);
  });

  /* --- Mobile filter drawer toggle --- */
  collectionSection.addEventListener('click', function (e) {
    if (e.target.closest('[data-filter-open]')) {
      if (filterDrawer) {
        filterDrawer.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      }
    }
    if (e.target.closest('[data-filter-close]')) {
      if (filterDrawer) {
        filterDrawer.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      }
    }
  });

  /* --- Price range inputs sync --- */
  collectionSection.querySelectorAll('[data-price-range]').forEach(function (group) {
    var minInput = group.querySelector('[data-price-min]');
    var maxInput = group.querySelector('[data-price-max]');
    var debounce;

    [minInput, maxInput].forEach(function (input) {
      if (!input) return;
      input.addEventListener('input', function () {
        clearTimeout(debounce);
        debounce = setTimeout(function () { applyFilters(true); }, 600);
      });
    });
  });

  /* --- Back/forward navigation --- */
  window.addEventListener('popstate', function () {
    location.reload();
  });

})();
